
// Packages
import axios from "axios";

const deleteTimeslot = (timeslot_id) => {
    /* 
        params:
            timeslot_id: int;
                - db id of timeslot
    */

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const token = localStorage.getItem("access_token");

    //axios call to Django view
    axios
    .delete(`${process.env.REACT_APP_API_BASE_URL}api/delete-time-slot/${timeslot_id}/`, 
        {
            headers : {
                Authorization: `Bearer ${token}`
            }
    })
    .then((response) => {
        if (response.status === 204) {
            console.log(response.data['status']);
        }
    })
    .catch((error) => {
        console.log(error)
    });
}

export default deleteTimeslot;